module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "otherbooks",
    attrs: {
      "id": "ded"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("We dedicate this book to our readers. May it become a pathfinder’s companion on the journey to the personal rediscovery of an intimate, separate self in wholesome relationship.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a25e436","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062043740_epub_ded_r1.vue
// module id = 63
// module chunks = 0